import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function AboutHero() {
  const { t } = useTranslation();
  return (
    <section className="relative min-h-[520px] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20digital%20network%20nodes%20glowing%20green%20teal%20lines%20connecting%20dark%20background%20tech%20infrastructure%20modern%20minimalist%20aesthetic%20soft%20light%20rays&width=1440&height=520&seq=about-hero-bg-001&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/50 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center pt-28 pb-16">
        <span
          className="inline-flex items-center gap-2 text-xs font-medium px-3 py-1.5 rounded-full mb-6"
          style={{ backgroundColor: "rgba(34,197,94,0.15)", color: "#4ade80", border: "1px solid rgba(74,222,128,0.3)" }}
        >
          <i className="ri-team-line text-xs"></i>
          {t("about.badge")}
        </span>
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-5 leading-tight">
          {t("about.hero.title")}
        </h1>
        <p className="text-base md:text-lg text-white/75 max-w-2xl mx-auto leading-relaxed mb-8">
          {t("about.hero.desc")}
        </p>
        <div className="flex items-center justify-center gap-3 flex-wrap">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-opacity hover:opacity-90"
            style={{ backgroundColor: "var(--accent)", color: "#000" }}
          >
            <i className="ri-mail-line text-sm"></i>
            {t("about.hero.cta1")}
          </Link>
        </div>
      </div>
    </section>
  );
}